import React from 'react';
import { IconProps } from '../types.ts';

const buildIconComponent = (
  muiIcon: React.ElementType,
): React.FC<IconProps> => {
  const IconHOC: React.FC<IconProps> = ({
    color,
    fontSize,
    styleOverrides,
    ...rest
  }) => {
    return React.createElement(muiIcon, {
      color,
      fontSize,
      sx: styleOverrides,
      ...rest,
    });
  };

  const IconComponent = muiIcon as React.FC;
  IconHOC.displayName = IconComponent.displayName;

  return IconHOC;
};

export default buildIconComponent;
